<section class="cmn-innerpage-wrapper">
  <div class="head">
    <div class="head-div">
      <div class="search-wrapper">
        <input
          type="text"
          class="cmn-header-search"
          placeholder="Search Tags"
          (input)="onSearch($event)"
        />
      </div>
      <button
        *appHasPermission="'ADD_TAG'"
        (click)="createNewtag()"
        class="cmn-add-btn"
      >
        <img src="assets/images/icons/icon-add.svg" alt="Add icon" />Add Tag
      </button>
    </div>
  </div>
  <div *ngIf="!loading">
    <div class="tagCategorySection" *ngIf="storyTags.length">
      <h3 class="categoryTitle">Story Tags</h3>
      <div class="tagsWrapper">
        <div class="tagItem" *ngFor="let tag of storyTags">
          <h6>{{ tag.tagName }}</h6>
          <button *appHasPermission="'DELETE_TAG'" (click)="onDeleteTag(tag.id)">
            <img class="tagRemoveIcon" src="../../../assets/images/icons/icon-delete.svg" alt="Remove" />
          </button>
          <button *appHasPermission="'UPDATE_TAG'" (click)="onEditTag(tag.id)">
            <img class="tagEditIcon" src="../../../assets/images/icons/icon-edit.svg" alt="Edit" />
          </button>
        </div>
      </div>
    </div>

    <div class="tagCategorySection" *ngIf="coloringImageTags.length">
      <h3 class="categoryTitle">Coloring Image Tags</h3>
      <div class="tagsWrapper">
        <div class="tagItem" *ngFor="let tag of coloringImageTags">
          <h6>{{ tag.tagName }}</h6>
          <button *appHasPermission="'DELETE_TAG'" (click)="onDeleteTag(tag.id)">
            <img class="tagRemoveIcon" src="../../../assets/images/icons/icon-delete.svg" alt="Remove" />
          </button>
          <button *appHasPermission="'UPDATE_TAG'" (click)="onEditTag(tag.id)">
            <img class="tagEditIcon" src="../../../assets/images/icons/icon-edit.svg" alt="Edit" />
          </button>
        </div>
      </div>
    </div>

    <div class="tagCategorySection" *ngIf="posterTags.length">
      <h3 class="categoryTitle">Poster Tags</h3>
      <div class="tagsWrapper">
        <div class="tagItem" *ngFor="let tag of posterTags">
          <h6>{{ tag.tagName }}</h6>
          <button *appHasPermission="'DELETE_TAG'" (click)="onDeleteTag(tag.id)">
            <img class="tagRemoveIcon" src="../../../assets/images/icons/icon-delete.svg" alt="Remove" />
          </button>
          <button *appHasPermission="'UPDATE_TAG'" (click)="onEditTag(tag.id)">
            <img class="tagEditIcon" src="../../../assets/images/icons/icon-edit.svg" alt="Edit" />
          </button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="noData">
    <app-no-data-component></app-no-data-component>
  </div>
  <app-content-loader [visible]="loading"></app-content-loader>
</section>
